var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelbeeLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.96,
    height: 37.192,
    viewBox: "0 0 35.96 37.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "welbee-logo-circle",
    transform: "translate(-0.003 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.003 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(0 0)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M128.982,42.078c.056.152.136.056.165.072C129.012,41.91,128.956,42.1,128.982,42.078Z",
    transform: "translate(-94.565 -30.814)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M123.067,33.1l.061.019a3.505,3.505,0,0,0-.3-.267C122.907,32.93,122.993,33.01,123.067,33.1Z",
    transform: "translate(-90.059 -24.086)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M118.5,26.22a.915.915,0,0,0,.3.5l.267.283a1.46,1.46,0,0,1,.192.3v.085l.237.08C119.2,27.028,118.681,26.551,118.5,26.22Z",
    transform: "translate(-86.884 -19.225)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M116.289,21.44c0,.112-.237-.173.189.248a.309.309,0,0,1-.021-.053C116.43,21.589,116.369,21.539,116.289,21.44Z",
    transform: "translate(-85.215 -15.72)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M117.065,22.041C117.244,22.236,117,21.87,117.065,22.041Z",
    transform: "translate(-85.823 -16.127)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M113.685,18.464l.3.2c-.021-.083-.237-.307-.131-.248C113.568,18.176,113.592,18.258,113.685,18.464Z",
    transform: "translate(-83.307 -13.395)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M112.61,18.47l.149.1C112.749,18.539,112.714,18.5,112.61,18.47Z",
    transform: "translate(-82.565 -13.543)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M113.478,19.081l-.312-.221c0,.056-.027.1.139.107C113.243,18.983,113.334,19,113.478,19.081Z",
    transform: "translate(-82.972 -13.829)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M114.752,20.33c.1.173.245.376-.032.165C115.176,20.968,115.214,20.8,114.752,20.33Z",
    transform: "translate(-84.112 -14.906)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M117.64,26.3l.107.235.184.133C117.84,26.6,117.677,26.246,117.64,26.3Z",
    transform: "translate(-86.253 -19.277)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M108.009,13.26c-.043.019.021.16,0,.216l.224.128C108.161,13.5,108,13.319,108.009,13.26Z",
    transform: "translate(-79.181 -9.723)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M107.159,13.557c-.115-.061-.224-.128-.339-.187C107.079,13.589,107.135,13.607,107.159,13.557Z",
    transform: "translate(-78.32 -9.803)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M111.658,18.653l.547.328-.635-.411Z",
    transform: "translate(-81.803 -13.616)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M103.16,9.831l.229.051L103,9.77C103.051,9.786,103.1,9.807,103.16,9.831Z",
    transform: "translate(-75.519 -7.164)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M98.71,6.978c.179.019-.125-.229.048-.181a2.18,2.18,0,0,0-.678-.227A1.641,1.641,0,0,1,98.71,6.978Z",
    transform: "translate(-71.912 -4.818)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M96.77,6.29c.107.029.221.051.35.075A1.66,1.66,0,0,0,96.77,6.29Z",
    transform: "translate(-70.952 -4.612)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M104.389,11.157a.456.456,0,0,0-.179-.267l.059.181Z",
    transform: "translate(-76.407 -7.985)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M103.707,11.045h0l-.267-.195Z",
    transform: "translate(-75.842 -7.956)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M104.912,11.941l-.032-.021C104.885,11.941,104.891,11.941,104.912,11.941Z",
    transform: "translate(-76.898 -8.74)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M108.249,15.631c-.213-.093-.608-.336-.331.024C108.091,15.7,107.928,15.49,108.249,15.631Z",
    transform: "translate(-79.055 -11.339)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M105.25,12.81l.312.253c0-.027-.021-.1.088-.064Z",
    transform: "translate(-77.169 -9.393)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M104.57,12.468l.181.085-.115-.093Z",
    transform: "translate(-76.671 -9.136)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M97.444,7.251a4.536,4.536,0,0,1-.534-.221c.1.064.2.123.3.181l.293.184C97.54,7.38,97.66,7.377,97.444,7.251Z",
    transform: "translate(-71.054 -5.155)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M101.525,9.593l-.035-.013C101.5,9.6,101.519,9.612,101.525,9.593Z",
    transform: "translate(-74.412 -7.025)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M89.54,3.79l.024.035.013-.016Z",
    transform: "translate(-65.651 -2.779)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M99.075,8.437a.736.736,0,0,0,.344.16c-.117-.059-.24-.123-.368-.2C99.025,8.405,99.025,8.413,99.075,8.437Z",
    transform: "translate(-72.611 -6.159)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M94.67,5.458a2.811,2.811,0,0,0,.245.192C94.851,5.578,94.71,5.448,94.67,5.458Z",
    transform: "translate(-69.412 -4.002)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M101.343,9.291h.024C101.332,9.251,101.332,9.264,101.343,9.291Z",
    transform: "translate(-74.3 -6.794)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M100.715,9.2a1.31,1.31,0,0,0-.235-.059c.1.045.187.088.267.117A.227.227,0,0,1,100.715,9.2Z",
    transform: "translate(-73.672 -6.702)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M85.322,4.382c.059-.093.52-.067.832.195.376.064.283-.35.029-.656-.029.043-.037.064-.438,0,.123.08.774.443.432.406-.5-.144-.384-.184-.611-.315.165.187-.691,0-.635.213l.451.061C85.381,4.32,85.216,4.32,85.322,4.382Z",
    transform: "translate(-62.271 -2.875)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M90.374,4.092l.16.048a2.351,2.351,0,0,1-.48-.344c-.267-.053-.342-.037-.374,0l.752.3Z",
    transform: "translate(-65.753 -2.759)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M93.513,5.588c-.165.045-.534-.085-.374.133.43.205.339.064.619.147-.707-.32.229.043-.245-.267.147.051.267.107.392.16-.12-.075-.235-.149-.339-.227v.016h0c.024.027.032.04,0,.016H93.55a.112.112,0,0,1-.051.021c-.192-.12-.019-.043.051-.021h.016A5.411,5.411,0,0,0,92.83,5.3,5.266,5.266,0,0,1,93.513,5.588Z",
    transform: "translate(-68.063 -3.887)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M106.308,15.784c-.013-.021,0-.029,0-.035C106.26,15.728,106.239,15.723,106.308,15.784Z",
    transform: "translate(-77.912 -11.537)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M105.294,13.789a.483.483,0,0,1,.248.141c.1.125-.037.043-.053.077.1.043.344.179.117-.083l-.051-.024c-.2-.237-.454-.566-.4-.552A.99.99,0,0,0,105.294,13.789Z",
    transform: "translate(-77.096 -9.788)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M99.086,9.73l-.576-.28.227.251.016-.059C99.052,9.864,99.022,9.746,99.086,9.73Z",
    transform: "translate(-72.227 -6.929)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M88.543,3.263l.123-.083a1.732,1.732,0,0,0-.416.035,2.588,2.588,0,0,1,.293.048Z",
    transform: "translate(-64.705 -2.332)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M85.8,2.316l.059-.091L85.62,2.22Z",
    transform: "translate(-62.777 -1.628)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    "data-name": "Path 381",
    d: "M21.67,116.49l.147.1A1.369,1.369,0,0,0,21.67,116.49Z",
    transform: "translate(-15.889 -85.41)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M18.3,112.9H18.24C18.3,112.927,18.333,112.943,18.3,112.9Z",
    transform: "translate(-13.374 -82.778)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_383",
    "data-name": "Path 383",
    d: "M15.106,27c-.253.152-.568.312-.448.358H14.8A1.478,1.478,0,0,1,15.106,27Z",
    transform: "translate(-10.728 -19.797)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    d: "M2.659,75.881l.04-.08c-.043-.064-.075-.125-.109-.181A1.666,1.666,0,0,0,2.659,75.881Z",
    transform: "translate(-1.9 -55.445)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M4.511,77.25,4.45,77.6A2.1,2.1,0,0,0,4.511,77.25Z",
    transform: "translate(-3.263 -56.64)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M43.69,130.127l.235-.04C43.623,129.978,43.735,130.082,43.69,130.127Z",
    transform: "translate(-32.034 -95.344)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M52.422,3.09a3.162,3.162,0,0,0-.592.1C52.123,3.167,52.372,3.2,52.422,3.09Z",
    transform: "translate(-38.002 -2.266)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M17,118.177c.093.075.144.093.163.075C17.053,118.177,17,118.137,17,118.177Z",
    transform: "translate(-12.465 -86.635)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M49.36,3.673a.36.36,0,0,0,.128-.016,2.839,2.839,0,0,1,.534-.2,1.147,1.147,0,0,0-.662.213Z",
    transform: "translate(-36.191 -2.537)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M125.05,101.668a.368.368,0,0,1,.035-.048C125.1,101.607,125.061,101.634,125.05,101.668Z",
    transform: "translate(-91.686 -74.505)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_391",
    "data-name": "Path 391",
    d: "M134.28,74.48V74.8A1.6,1.6,0,0,0,134.28,74.48Z",
    transform: "translate(-98.454 -54.609)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M73.59.14C73.774.14,73.622.124,73.59.14Z",
    transform: "translate(-53.956 -0.098)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M76.507,2.18a.08.08,0,0,0-.077.048A.139.139,0,0,1,76.507,2.18Z",
    transform: "translate(-56.039 -1.599)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M44.163,9.14H44.15C44.206,9.145,44.2,9.145,44.163,9.14Z",
    transform: "translate(-32.371 -6.702)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M73.979.286A1.932,1.932,0,0,0,73.75.23C73.787.241,73.857.259,73.979.286Z",
    transform: "translate(-54.074 -0.169)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M74.48.219l.16.029C74.664.23,74.643.216,74.48.219Z",
    transform: "translate(-54.609 -0.161)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M72.64.165a2.123,2.123,0,0,1,.3.013c-.037,0-.051-.016-.043-.019Z",
    transform: "translate(-53.26 -0.118)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M87.67,133.995h.037C87.862,133.907,87.793,133.933,87.67,133.995Z",
    transform: "translate(-64.28 -98.203)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M11.423,43.729V43.71l-.013.021Z",
    transform: "translate(-8.366 -32.048)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M10.235,44.387a.71.71,0,0,1,.144-.587L10,43.853Z",
    transform: "translate(-7.333 -32.114)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M8.147,33.142l-.267-.331c.5.163.771.4.534.067-.125.133-.459-.1-.8-.326s-.638-.494-.779-.376c-.056-.075-.1-.16-.155-.24.056.056.077.048.133.1-.267-.494-.478-.064-.942-.595-.152-.192-.232-.35-.085-.267-.144-.109-.3-.211-.438-.331-.1-.123-.024-.136.072,0-.187-.2-.376-.4-.56-.6h0A4.285,4.285,0,0,1,4.4,29.95c-.088-.2.1.059.1,0-.117-.1-.24-.2-.35-.312-.016-.107.051-.093.139-.021a1.561,1.561,0,0,1,.307.323.411.411,0,0,0-.189-.438,1.473,1.473,0,0,1-.467-.683l.28.326a.947.947,0,0,0-.131-.47,4.333,4.333,0,0,1-.235-.576c0,.123.227.987-.1.619a1.254,1.254,0,0,0-.336-.488c.1-.064-.045-.267-.205-.56l.163-.061c-.208-.283-.28-.216-.435-.371a.6.6,0,0,1,0-.619c-.232-.576-.021.48-.35-.184a3.012,3.012,0,0,0-.267-.67c-.1-.216-.216-.438-.366-.72-.059-.366.12.032.125-.109-.077-.088-.147-.181-.219-.267-.019-.08.029-.067.053-.059-.123-.251-.171.024-.331-.384-.109-.032-.091-.267-.085-.552a2.508,2.508,0,0,0-.016-.446,1.067,1.067,0,0,0-.1-.446c.027-.136.112.048.173,0-.267-.7-.189-.606-.44-1.193.016-.176.045-.35.077-.534-.112.39-.283-.088-.427-.534-.056.139-.1.267-.128.339-.037-.232-.085-.464-.107-.7.029-.085.088,0,.157.1-.013-.045-.027-.091-.04-.125.067-.251.163-.12.267.056-.035.085-.072.168-.107.251.112.171.232.323.331.285a.846.846,0,0,1-.067-.2c.032.043.056.069.072.048s-.027-.091-.072-.192l.192-.155-.075-.037c.048-.3.077-.59.141-.88a6.163,6.163,0,0,1-.309-2.265c.1.267.216.088.376.128-.227.248-.027.8-.128,1.307.051-.267.123-.2.141-.131l-.045-.95c.131.04.133-.181.227-.414-.293.141-.069-.72-.061-1.11.093,0,.165.1.051.555.3-.462-.181-.718.1-1.174-.024.112-.056.168-.019.221-.016-.267.208-.894.245-.726l-.027.112c.1-.366.267-.91.392-1.39a2.02,2.02,0,0,0,.133-.982,1.041,1.041,0,0,1,.243.251c-.069-.5-.141-1.027-.168-1.55.125.189.736-.024.576.584a2.207,2.207,0,0,0,.32-.7c-.083.091-.382.149-.331,0a4.816,4.816,0,0,0,.691-.667c-.12.141-.3-.187-.136-.435.016.064.267.131.248.237.035-.267.064-.518.112-.774-.053.181.2.16.358.075-.088.032.334-.52.43-.683-.077.069-.16.133-.232.208.5-.632.12-.9.651-1.539-.013.12.139.427.432.141a5.091,5.091,0,0,1,.051-.728A2.385,2.385,0,0,1,6.05,5.9l.163-.035c.117-.155.229-.312.35-.464-.056.205-.179.571-.309.939s-.267.752-.358,1.017c.253-.179.128,0,.432-.328.171-.056-.08.267-.163.36.251-.237.5-.48.763-.7-.163-.1.456-.678.334-.755-.125.144-.243.3-.358.454s-.237.3-.344.462c-.077-.045-.059-.267.067-.51a2.281,2.281,0,0,1,.646-.8c.192-.072.1.336.152.371a1.35,1.35,0,0,1,.251-.32,1.145,1.145,0,0,1,.3-.232l-.187.267c.363-.2.384-.611.894-.763.147-.1.555-.1.52-.205-.347-.016-.758-.5-.68-.739l.5-.192a4.066,4.066,0,0,1,.63-.171c.328,0-.176.555.107.534-.016-.048.088-.181.133-.232.179-.056,0,.165.344-.048-.032-.189.712-.376.088-.224.318-.237.384-.163.8-.376-.091-.021-.045-.157.069-.315a1.956,1.956,0,0,1,.472-.44c0,.053.1.069.155.08.723-.291,1.166-.366,1.881-.6.077.016.44-.035.318.083a1.161,1.161,0,0,1,.392-.219c.472.024-.486.168-.107.267,0-.115.534-.3.835-.451-.139-.131-.75.163-1.041.328-.069-.213.416-.619,1.177-.9.608-.2.3.08.4.021A2.807,2.807,0,0,0,16.709.69a1.371,1.371,0,0,1,.928-.184c.414.1.045.267.144.374A11,11,0,0,1,16.637.94h.435a1.937,1.937,0,0,1-.678.155A10.406,10.406,0,0,0,17.63,1l.435-.04A2.4,2.4,0,0,1,18.5.94a6.524,6.524,0,0,1,.8.053c.16-.048.443-.1.315-.155l-.291.019c-.267-.115.555-.16.187-.213a3.49,3.49,0,0,1,1.4-.019L21,.8a.8.8,0,0,0-.51-.1,1.39,1.39,0,0,1,.534.115.72.72,0,0,0,.558.061L21.216.687c.2,0,.435-.021.678-.019a1.726,1.726,0,0,1,.731.117C22.443.57,22.515.756,22.206.5c.267.291-1.27-.267-.824.077C21.045.263,20.757.369,20.3.14c0,.053.16.117-.267.051a.475.475,0,0,1-.1.037h-.005a.6.6,0,0,1,.208.1A1.822,1.822,0,0,1,19.58.4a4.8,4.8,0,0,0-.558.069c-.248-.024.1-.061-.032-.117l-.312.1C18.644.329,18,.249,18.6.183h-.267L18.062.2a3.058,3.058,0,0,0-1.035.059c-.267,0-.6.235-.4.1-.267.069-.534.147-.8.227V.564a22.309,22.309,0,0,1-2.516.659,6.422,6.422,0,0,1-.953.376l-.123-.067c-.315.171-1.025.312-1.113.48a1.925,1.925,0,0,0-1.038.35c-.406.224-.8.51-1.089.656l.051.128a4.269,4.269,0,0,0-.534.363c-.179.136-.363.283-.56.464l.1.077c-.307.342-.993.627-1.526,1.121,0-.067.155-.176.267-.24a2.687,2.687,0,0,0-1,.878,4.208,4.208,0,0,1-.851.947,1.118,1.118,0,0,1-.309.36.237.237,0,0,0,.024-.043L4.6,7.136c-.069.053-.144.109-.219.173A1.569,1.569,0,0,0,4.57,7.17c-.091.117-.221.307-.339.5h-.16l-.027.045c-.168.152-.056.179.091.144a1.686,1.686,0,0,0-.109.283c-.136,0-.208.141-.285.267s-.149.28-.309.32a3.1,3.1,0,0,1-.227.6c-.109.267-.2.512-.133.619-.029,0-.075.04-.016-.061a1.7,1.7,0,0,0-.339.622l-.192.019c-.021.192-.029.387-.037.579-.227.253-.339.355-.315,0-.08.4-.123.552-.16.694a3.252,3.252,0,0,0-.1.608l-.088-.067c-.083.224-.069.63-.2.734a1.958,1.958,0,0,0-.283.614,9.888,9.888,0,0,0-.3.985c-.048.184-.1.376-.147.568s-.088.39-.141.584c-.1.384-.181.763-.283,1.094.35-.216-.237.606,0,.7-.083.067-.147.267-.184.024a5.87,5.87,0,0,1-.1.843,1.446,1.446,0,0,0,.048.7c-.08.077-.1-.157-.147-.088,0,.059.051.229,0,.3S.029,19.286,0,19.171c-.027.728.219.8.424.859a.84.84,0,0,0,.064.8c-.064.125-.128.342-.171-.1,0,.123-.019.507,0,.862s.085.675.171.678a.8.8,0,0,0,.064.408,6.913,6.913,0,0,0,.2,1.139v-.152c.267.165.125.438.267.854H1c.136,1.011.187.4.339,1.4l.1-.1c.141,0,.173.219.224.5a2.084,2.084,0,0,0,.267.875l-.021-.219c.219.243.029.966.165,1.267,0,.075-.085-.08-.149-.16.267.83.2.021.534.555-.019.147-.28,0-.072.36a2.716,2.716,0,0,0,.491.606,2.911,2.911,0,0,1,.624.84c-.024-.144-.045-.283.176-.085a6.454,6.454,0,0,1,.438.694,1.334,1.334,0,0,0,.558.56c.024.059.027.083.016.1a4.823,4.823,0,0,0,1.081.768.587.587,0,0,0,.235.44,4.461,4.461,0,0,0,.582.414c.205.136.411.248.55.35s.205.2.147.28c.283.205.587.379.883.566l-.045.019a2.038,2.038,0,0,0,1.067.432c.123.1,0,.077-.016.091a5.839,5.839,0,0,0,.883.486,4.8,4.8,0,0,0,.88.189l.029.155a4.928,4.928,0,0,1,.832.368,4.832,4.832,0,0,0,.672.267,3.042,3.042,0,0,0,.728.157.213.213,0,0,1-.117.032,4.461,4.461,0,0,1,.846.192c.288.077.579.168.851.245.534.147,1.025.205,1.246,0l.712-.059c-.9-.112.152-.2-.211-.307.352,0,.9.219.467.208l-.067-.029c-.179.267,1.121.139,1.094.3a23.933,23.933,0,0,0,5.232-.392l-.232-.152c.192-.032.384-.077.574-.123.16,0,.24.1-.171.192a.926.926,0,0,0,.662-.307c.8-.157-.248.312,0,.243.112-.032.219-.075.328-.112h-.08a1.828,1.828,0,0,1,.731-.39c.315-.069.195.059.318.024,0,.013.045,0,.184-.061a7.1,7.1,0,0,0,.707-.267l-.336-.029c.267-.2.651-.267.267-.291a1.515,1.515,0,0,0,.646-.144c.133-.051.28-.109.43-.176l.446-.229c.595-.318,1.123-.691,1.273-.747a9.253,9.253,0,0,1,1.134-.966c-.128.067-.3-.016.08-.309.048.189.248.083.483-.1a2.57,2.57,0,0,1,.739-.486c-.184.072.051-.192.267-.44s.368-.5.1-.368c.283-.293.115.067.382-.117a23.67,23.67,0,0,0,1.868-2.8c-.032-.037-.189.109-.133-.149.165-.155.318-.315.48-.478.077-.229-.155-.3.152-.648-.059.043-.147.107-.1-.048a11.316,11.316,0,0,0,1-3.415c.187-1.187.288-2.375.515-3.562-.091.323-.1.107-.1-.139-.024.16-.117,0-.181.027.061-.328.12-.659.163-.993-.093-.085-.1-.352-.117-.606s-.043-.5-.131-.534l.053.309c-.227-.4-.4.6-.667.552a1.335,1.335,0,0,1-.013.859,1.806,1.806,0,0,0,.019,1.067c-.059.16-.077-.141-.139-.056a1.243,1.243,0,0,1,.043.832l-.043-.04c-.019.293-.043.534-.069.776s-.077.44-.12.654-.1.432-.163.672-.128.512-.224.824l.147-.067a1.676,1.676,0,0,1-.192.44c.115.363.187-.768.328-.435a3.671,3.671,0,0,0-.419,1.1c-.152.462-.307.9-.48.966-.157.4.184-.067.027.334l-.117.077.056.139c-.115.267-.267.35-.336.331a1.086,1.086,0,0,0,.083-.267c-.224.3-.387.947-.48,1.041.077-.115.157-.227.227-.344A18.755,18.755,0,0,1,31.2,31.143l.1-.027a2.182,2.182,0,0,1-.534.6,5.579,5.579,0,0,0-.632.579v-.035a1.921,1.921,0,0,1-.478.534c.139-.208-.43.189-.24-.075a2.85,2.85,0,0,0-.451.5,1.462,1.462,0,0,1-.232.406h-.176a1.217,1.217,0,0,1-.515.534c.293-.267-.339.029-.021-.293a3.847,3.847,0,0,0-1.027.571.947.947,0,0,1-.728.267c-.307.446.851-.232.643-.069.237-.019-.267.347-.56.459a1.334,1.334,0,0,1-.534.032,2.425,2.425,0,0,0-.864.147c.077-.024.075-.045.152-.072-.307.035-.534.288-.918.283-.149.219-.462.128-.464.344.237-.075.467-.173.7-.267-.195.085-.368.221-.584.336a2.081,2.081,0,0,1-.838.235,1.825,1.825,0,0,1,.366-.221c-.211,0-.371.136-.592.112,0-.211.872-.243,1.259-.534-.227-.016-.782.36-.619.088-.243.368-.776.144-1.267.467l.013-.128a1.782,1.782,0,0,1-.408.141l.267-.208c-.411.211-.854.016-1.262.133.878-.107.216.128.6.173-1.067.3-.664-.24-1.868-.093.165-.029.624.032.371.109a2.353,2.353,0,0,1-.688-.1c-.8.043.128.125-.213.211-.267-.149-.4.075-.758.125v-.128c-.923-.112-.267.267-1.089.133.12-.051.24-.109.36-.165-.144,0-.291.027-.435.027l.1-.139a2.471,2.471,0,0,1-1.067-.056c.1.107-.085.224-.5.173-.267-.112.173-.1-.408-.16a.486.486,0,0,1,.534,0c.029-.037.139-.061.168-.1a4.469,4.469,0,0,0-.945-.163,1.131,1.131,0,0,1,.216.072l-.856.019c-.12-.072,0-.091.1-.107a3.332,3.332,0,0,1-.534-.037c.088-.088.1-.192.448-.163-.267-.019-.534-.048-.8-.072-.04-.056-.36-.224-.251-.235a2.737,2.737,0,0,0-.758-.16,2.7,2.7,0,0,1-.848-.245.5.5,0,0,1-.221-.024c-.248-.12-.47-.267-.71-.379a3.257,3.257,0,0,0-.814-.334c-.083-.107-.157-.227-.232-.339-.462-.213.32.454-.454.1-.555-.248-.115-.248-.267-.4a2.063,2.063,0,0,1-1.2-.654A4.449,4.449,0,0,1,8.147,33.142ZM3.761,28.707c.083.093.291.245.28.36C3.841,29.035,3.831,28.918,3.761,28.707ZM1.018,19.58a.632.632,0,0,1-.035.4,1.249,1.249,0,0,1,.035-.4ZM17.643.319H17.63C17.344.305,17.438.316,17.643.319Zm.616,0c.061-.024.056-.043.029-.056a.8.8,0,0,1-.336.059A.387.387,0,0,0,18.26.311Zm7.161,35.87H25.3C25.535,36.071,25.477,36.122,25.421,36.188Z",
    transform: "translate(-0.003 -0.103)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M4.277,77.16a.1.1,0,0,1-.067.056C4.234,77.264,4.258,77.264,4.277,77.16Z",
    transform: "translate(-3.087 -56.574)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M43.53,130.356h.016l.027-.016Z",
    transform: "translate(-31.917 -95.565)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M36.747,14.74a.7.7,0,0,1-.227.061C36.531,14.831,36.589,14.828,36.747,14.74Z",
    transform: "translate(-26.777 -10.808)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M79.575.685,79.18.64a1.089,1.089,0,0,1,.342.112C79.519.72,79.452.664,79.575.685Z",
    transform: "translate(-58.055 -0.47)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M91.5,7.061c.059,0,.109.04.165.045V7.048C91.46,6.965,91.3,6.949,91.5,7.061Z",
    transform: "translate(-67.021 -5.119)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M81.68,2.65c0,.112.251.12.518.157h-.045C82.267,2.666,81.971,2.655,81.68,2.65Z",
    transform: "translate(-59.888 -1.944)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M83.85,3.29a1.74,1.74,0,0,1,.237.069C84.133,3.309,83.994,3.317,83.85,3.29Z",
    transform: "translate(-61.479 -2.413)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M70.63.132c.131.027.083-.139.157-.093C70.935-.1,69.913.2,70.63.132Z",
    transform: "translate(-51.597 -0.002)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M81.552,3.7l-.067-.149-.165.077Z",
    transform: "translate(-59.624 -2.603)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M74.52,2.562l.419.08c0-.024.051-.032.117-.035C74.8,2.578,74.514,2.522,74.52,2.562Z",
    transform: "translate(-54.638 -1.869)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M76.53,2.758a1.417,1.417,0,0,0,.342,0A3.223,3.223,0,0,0,76.53,2.758Z",
    transform: "translate(-56.112 -2.019)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M78.936,3.51l-.117-.053L78.53,3.39Z",
    transform: "translate(-57.578 -2.486)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M56.4,4.14c-.147.051-.293.093-.44.147-.032.059.093.048.267,0C56.311,4.225,56.474,4.169,56.4,4.14Z",
    transform: "translate(-41.024 -3.036)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M62.406,4.277a.459.459,0,0,1-.216-.067l.016.165Z",
    transform: "translate(-45.598 -3.087)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M57.337,5.542c-.035.056-.606.267-.051.136C57.319,5.624,57.751,5.483,57.337,5.542Z",
    transform: "translate(-41.826 -4.053)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M34.074,13.875l.1-.067-.16-.219Z",
    transform: "translate(-24.937 -9.965)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M19.184,29.917c.376-.366-.056-.2.3-.518.027-.139-.293.267-.267.125C19.083,29.8,18.954,29.925,19.184,29.917Z",
    transform: "translate(-13.974 -21.534)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M19.7,29.582a1.358,1.358,0,0,0,.069-.152A.8.8,0,0,0,19.7,29.582Z",
    transform: "translate(-14.445 -21.578)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M134.543,68.56l.029-.36-.072.237Z",
    transform: "translate(-98.615 -50.004)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M133.7,66.236l.165-.1-.171-.2A.619.619,0,0,1,133.7,66.236Z",
    transform: "translate(-98.021 -48.347)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M13.318,103.56H13.27a.548.548,0,0,0,.088.267Z",
    transform: "translate(-9.73 -75.93)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M23.059,117.009l-.051-.059-.008.216Z",
    transform: "translate(-16.864 -85.747)",
    fill: "#ffcf05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M33.694,124.447c-.133-.077-.3-.147-.424-.237C33.561,124.37,33.63,124.634,33.694,124.447Z",
    transform: "translate(-24.394 -91.07)",
    fill: "#ffcf05"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M52.451,51.455H51.72a.8.8,0,0,0-.752.56l-2.2,7.471-2.567-7.5a.8.8,0,0,0-.742-.534H44.373a.782.782,0,0,0-.742.534L41.109,59.5l-2.225-7.471a.784.784,0,0,0-.75-.56h-.776a.782.782,0,0,0-.744,1.025l3.18,9.779a.776.776,0,0,0,.744.534h1.027a.782.782,0,0,0,.744-.534l2.473-7.551,2.8,7.577a.8.8,0,0,0,.736.507h.971a.779.779,0,0,0,.739-.534L53.2,52.477a.782.782,0,0,0-.744-1.022Z",
    transform: "translate(-26.817 -37.723)",
    fill: "#eb5b41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelbeeLogoCircle);
export default __webpack_public_path__ + "static/media/welbee-logo-circle.d3ef6e9c50391a7c218a69a367183e18.svg";
export { ForwardRef as ReactComponent };